import ModelEditDto from 'app/admin/model/dto/ModelEditDto';
import PetrosimModelInputAttributeEditDto from './PetrosimModelInputAttributeEditDto';
import PetrosimModelOutputAttributeEditDto from './PetrosimModelOutputAttributeEditDto';

export class PetrosimModelEditDto extends ModelEditDto {
	constructor() {
		super();
		/** @type {string} */
		this.hsc_file = null;
		/** @type {PetrosimModelInputAttributeEditDto[]} */
		this.inputAttributes = null;
		/** @type {PetrosimModelOutputAttributeEditDto[]} */
		this.outputAttributes = null;
	}

	/**
	 * @typedef {Object} _PetrosimModelEditDtoProps
	 * @property {string} hsc_file
	 * @property {PetrosimModelInputAttributeEditDto[]} inputAttributes
	 * @property {PetrosimModelOutputAttributeEditDto[]} outputAttributes
	 *
	 * @typedef {import("app/admin/model/dto/ModelEditDto").ModelEditDtoProps & _PetrosimModelEditDtoProps} PetrosimModelEditDtoProps
	 */
	/**
	 *
	 * @param {PetrosimModelEditDtoProps} props
	 * @returns {PetrosimModelEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.hsc_file = props.hsc_file;
		this.inputAttributes = props.inputAttributes !== null ? props.inputAttributes.map(d => new PetrosimModelInputAttributeEditDto().setup(d)) : [];
		this.outputAttributes = props.outputAttributes !== null ? props.outputAttributes.map(d => new PetrosimModelOutputAttributeEditDto().setup(d)) : [];
		return this;
	}
}

export default PetrosimModelEditDto;
